import { render, staticRenderFns } from "./taskDeliverModify.vue?vue&type=template&id=af4767e6&scoped=true"
import script from "./taskDeliverModify.vue?vue&type=script&lang=js"
export * from "./taskDeliverModify.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverModify.vue?vue&type=style&index=0&id=af4767e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4767e6",
  null
  
)

export default component.exports